export default "__VITE_ASSET__DvdYZDDZ__";